import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { formatInvestorVehicle } from './format';
import dt from '../../../shared/theme';

const Container = styled.span`
  display: flex;
  align-items: center;
  height: 14px;
  margin: 0 16px;
  text-transform: uppercase;
  border: 1px solid #627484;
  box-sizing: border-box;
  border-radius: 2.4px;
  font: ${props => dt(props).theme.fontWeightBold} 10px/12px ${props => dt(props).theme.fontFamilyBody};
  color: #627484;
`;

const Tag = styled.span`
  padding: 0 4px;
  margin: 0;
`;

export default function InvestorVehicle({ name }) {
  const label = formatInvestorVehicle(name);

  if (!label) {
    return null;
  }
  return (
    <Container className="tag-container">
      <Tag>{label}</Tag>
    </Container>
  );
}

InvestorVehicle.propTypes = { name: PropTypes.string };

InvestorVehicle.defaultProps = {
  name: null,
};
